export enum NotificationType {
    Off = 3,
    Email = 2
}
